import { render, staticRenderFns } from "./TaxesDetail.vue?vue&type=template&id=26cf9c6c"
import script from "./TaxesDetail.vue?vue&type=script&lang=js"
export * from "./TaxesDetail.vue?vue&type=script&lang=js"
import style0 from "./TaxesDetail.vue?vue&type=style&index=0&id=26cf9c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports